import store from "@/store/index";
import beforeAxios from "axios";
import { ENV, GIT_REV } from "@/constants/env";
import { ExceptionSentryHandler } from "./sentry";

const APP_ENV_API = {
  dev: "https://api-clients.dver.link",
  qa: "https://api-clients.dver.pe.kr",
  prod: "https://api-clients.dver.co.kr",
};
const axios = beforeAxios.create({
  baseURL: APP_ENV_API[ENV],
});

const praseUrl = (url) => {
  // '/' 확인
  const checkLastString = url.substr(url.length - 1, 1);
  if (checkLastString === "/") url = url.substr(0, url.length - 1);

  // rev 추가
  const findQueryString = url.indexOf("?");
  if (findQueryString === -1) url = url + `?rev=${GIT_REV}`;
  else url = url + `&rev=${GIT_REV}`;

  return url;
};

/*

  axios 인터셉터 선언부분

*/
export function axiosInterceptor() {
  axios.interceptors.request.use(async (req) => {
    req.url = praseUrl(req.url);
    if (req.headers.bypass) {
      req.headers.authorization = store.state.auth.accessToken;
      delete req.headers["bypass"]; // delete bypass headers
      return req;
    }
    const isAuthenticated = store.getters["auth/isAuthenticated"](); // accessToken check
    if (!isAuthenticated) {
      try {
        await store.dispatch("auth/refreshSignin");
        req.headers.authorization = store.state.auth.accessToken;
        return req;
      } catch (e) {
        return Promise.reject(e);
      }
    }
    req.headers.authorization = store.state.auth.accessToken;
    return req;
  });

  axios.interceptors.response.use(
    (response) => {
      new ExceptionSentryHandler(response).apiException();

      if (response.data.code === 4000) {
        const payload = { isModalOpen: true, popupMsg: response.data.popup };
        store.dispatch("setPopupModalVisible", payload);
      }
      return response;
    },
    (error) => {
      new ExceptionSentryHandler(error).apiException();

      return Promise.reject(error);
    }
  );
}
/*


  API URL 출력


*/
export const baseURL = APP_ENV_API[ENV];

export default axios;
